module.exports = __webpack_public_path__ + "files/55e0dc014ff9532a60f9d486b44e217e.png";